// NFT Collection Data
export const nftCollection = [
  {
    id: 0,
    title: "CVMech NFT #1",
    image: "/assets/NFT-21.png",
  },
  {
    id: 1,
    title: "CVMech NFT #2",
    image: "/assets/NFT-2(1).png",
  },
  {
    id: 2,
    title: "CVMech NFT #3",
    image: "/assets/NFT-3.png",
  },
  {
    id: 3,
    title: "CVMech NFT #4",
    image: "/assets/NFT-4.png",
  },
  {
    id: 4,
    title: "CVMech NFT #5",
    image: "/assets/NFT-5.png",
  },
  {
    id: 5,
    title: "CVMech NFT #6",
    image: "/assets/NFT-6.png",
  },
  {
    id: 6,
    title: "CVMech NFT #7",
    image: "/assets/NFT-7.png",
  },
  {
    id: 7,
    title: "CVMech NFT #8",
    image: "/assets/NFT-8.png",
  },
  {
    id: 8,
    title: "CVMech NFT #9",
    image: "/assets/NFT-9.png",
  },
  {
    id: 9,
    title: "CVMech NFT #10",
    image: "/assets/NFT-10.png",
  },
  {
    id: 10,
    title: "CVMech NFT #11",
    image: "/assets/NFT-11.png",
  },
  {
    id: 11,
    title: "CVMech NFT #12",
    image: "/assets/NFT-12.png",
  },
  {
    id: 12,
    title: "CVMech NFT #13",
    image: "/assets/NFT-13.png",
  },
  {
    id: 13,
    title: "CVMech NFT #14",
    image: "/assets/NFT-14.png",
  },
  {
    id: 14,
    title: "CVMech NFT #15",
    image: "/assets/NFT-15.png",
  },
  {
    id: 15,
    title: "CVMech NFT #16",
    image: "/assets/NFT-16.png",
  },
  {
    id: 16,
    title: "CVMech NFT #17",
    image: "/assets/NFT-17.png",
  },
  {
    id: 17,
    title: "CVMech NFT #18",
    image: "/assets/NFT-18.png",
  },
  {
    id: 18,
    title: "CVMech NFT #19",
    image: "/assets/NFT-19.png",
  },
  {
    id: 19,
    title: "CVMech NFT #20",
    image: "/assets/NFT-20.png",
  },
];
